export default {
  LOAD_STUDENT_COMPETENCY_SURVEY_LIST_START: 'LoadStudentCompetencySurveyListStart',
  LOAD_STUDENT_COMPETENCY_SURVEY_LIST_END: 'LoadStudentCompetencySurveyListEnd'
};